import React from "react";
import s from "./W1Sidebar.module.css";

export default function W1Sidebar({
  gerencias,
  gerencia,
  setGerencia,
  coordenadores,
  coordenador,
  setCoordenador,
  onBack,
  onAddLine,
  onSaveAll,
  salvando,
  podePreencher,
  erroSalvar,
}) {
  return (
    <aside className={s.sidebar}>
      <button className={s.menu} onClick={onBack}>Menu Principal</button>

      <div className={s.group}>
        <label>Gerências:</label>
        <select value={gerencia} onChange={(e) => setGerencia(e.target.value)}>
          <option value="">Selecione...</option>
          {gerencias.map((g, i) => (
            <option key={i} value={g}>{g}</option>
          ))}
        </select>
      </div>

      <div className={s.group}>
        <label>Coordenadores:</label>
        <select
          value={coordenador}
          onChange={(e) => setCoordenador(e.target.value)}
          disabled={!gerencia}
        >
          <option value="">Selecione...</option>
          {coordenadores.map((c, i) => (
            <option key={i} value={c}>{c}</option>
          ))}
        </select>
      </div>

      <div className={s.actions}>
        <button type="button" onClick={onAddLine}>Adicionar Nova Linha</button>
        <button
          type="button"
          onClick={onSaveAll}
          className={s.save}
          disabled={salvando || !podePreencher}
          title={!podePreencher ? "Selecione Gerência e Coordenador" : ""}
        >
          {salvando ? "Salvando..." : "Salvar"}
        </button>
        {erroSalvar ? <div className={s.saveError}>{erroSalvar}</div> : null}
      </div>
    </aside>
  );
}
